// src/App.js
import { useEffect } from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { STORAGE_KEYS } from "./core/config";
import Chatbot from "./components/Chatbot";

function AuthGate({ children }) {
  const { loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    try {
      const token = window.localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) {
        window.location.replace("/login.html");
      }
    } catch {
      window.location.replace("/login.html");
    }
  }, [loading]);

  if (loading) {
    return <div className="auth-loading">Loading…</div>;
  }

  try {
    if (!window.localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)) {
      return null;
    }
  } catch {
    return null;
  }

  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AuthGate>
          <Chatbot />
        </AuthGate>
      </AuthProvider>
    </ThemeProvider>
  );
}
